import { httpClient } from '@/services/http/httpClient'

export type CreateTaskCommentProps = {
  taskId: string
  comment: string
  attachment?: File
  projectId: string
}

export async function createTaskComment({
  comment,
  taskId,
  attachment,
  projectId,
}: CreateTaskCommentProps) {
  const payload = new FormData()
  payload.append('comment', comment)
  payload.append('taskId', taskId)

  if (attachment) {
    payload.append('file', attachment)
  }

  await httpClient.post(`/projects/task-comments/${projectId}`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
